const kz = {
  welcome: "Қош келдіңіз",
  language: "Тіл",
  switch_language: "Тілді ауыстыру",
  about: "Команда",
  pipeline: "Пайплайн",
  models: "Модельдер",
  login: "Кіру",
  register: "Тіркелу",
  ai_services: "Қазақ тіліне арналған AI қызметтері",
  goal: "Мақсатымыз – қазақ тілінде жасанды интеллект мүмкіндіктерін кеңейту арқылы пайдаланушыларға мәтінмен, дыбыспен және кескіндермен жұмыс істеуді жеңілдету. Біз тапсырмаларды автоматтандыруға, деректерді цифрландыруға және қазақ тіліндегі AI қызметтерінің сапасын арттыруға ұмтыламыз. ",
  our_services: "Қызметтеріміз",
  text_to_speech: "Мәтінді дауысқа айналдыру",
  llm: "Үлкен тілдік модель",
  speech_to_text: "Дыбысты мәтінге айналдыру",
  named_entity_recognition: "Атаулы объектілерді тану",
  ocr: "Оптикалық таңбаларды тану",
  image_captioning: "Суретке сипаттама жасау",
  footer: {
    rights: "Барлық құқықтар қорғалған.",
  },
  text_to_speech_desc: "Жазбаша мәтінді оңай дыбыстаңыз.",
  named_entity_recognition_desc:
    "Мәтіндегі атаулар мен маңызды объектілерді анықтаңыз.",
  llm_desc:
    "Күрделі мәтіндік тапсырмаларды орындаңыз, сұрақтарға жауап алыңыз немесе жаңа мәтін жазыңыз.",
  speech_to_text_desc: "Дыбысты мәтінге оңай айналдырып, транскрипция жасаңыз.",
  ocr_desc: "Суреттер мен сканерленген құжаттардан мәтінді шығарып алыңыз.",
  login_desc: "Қосымша мүмкіндіктерге қол жеткізу үшін кіріңіз.",
  register_desc: "Қосымша мүмкіндіктерге қол жеткізу үшін тіркеліңіз.",
  username: "Логин",
  password: "Құпия сөз",
  enterUsername: "Логин енгізіңіз",
  enterPassword: "Құпия сөзді енгізіңіз",
  enter_text: " Мәтінді дауысқа айналдыру үшін мәтінді енгізіңіз",
  convertToSpeech: "Дыбыстау",
  question: "Сұрақ",
  response: "Жауап",
  enterQuestion: "Сұрағыңызды енгізіңіз",
  text_summarization: "Мәтінді қысқаша мазмұндау",
  summarize: "Қысқаша мазмұндау",
  qa: "Сұрақтарға жауап беру",
  machine_translation: "Машиналық аударма",
  optical_character_recognition_desc:
    "Суреттерден немесе сканерленген құжаттардан мәтінді шығарады.",
  image_captioning_desc: "Суретке сипаттамалық мәтін жасайды.",
  text_summarization_desc: "Берілген мәтінді қысқаша мазмұндайды.",
  question_answering_desc:
    "Берілген мәтін немесе контекст бойынша сұрақтарға жауап береді.",
  machine_translation_desc: "Мәтінді бір тілден екінші тілге аударады.",
  generated_images: "Генерацияланған суреттер",
  generate_images: "Суреттерді генерациялау",
  generated_videos: "Генерацияланған бейнелер",
  generate_videos: "Бейнелерді генерациялау",
  no_images: "Генерацияланған суреттер жоқ.",
  no_videos: "Генерацияланған бейнелер жоқ.",
  enter_your_text: "Мәтініңізді енгізіңіз",
  enter_your_video_text: "Бейнеңіз үшін мәтінді енгізіңіз",
  recognized_entities: "Танылған объектілер",
  query_history: "Іздеу тарихы",
  extract_entities: "Объектілерді шығару",
  llm_chat: "Үлкен тілдік модельмен чат",
  start_new_chat: "Жаңа чат бастау",
  send: "Жіберу",
  search: "Іздеу",
  no_chat_seleted: "Чат таңдалмаған",
  search_results: "Іздеу нәтижелері",
  text_id: "Мәтін ID",
  text_score: "Мәтін балы",
  transcription: "Транскрипция",
  transcription_desc: "Транскрипция осы жерде пайда болады",
  stop_recording: "Транскрипцияны тоқтату",
  start_recording: "Транскрипцияны бастау",
  extracted_text: "Шығарылған мәтін",
  extract_text: "Мәтінді шығару",
  upload_image: "Суретті жүктеу",
  extracted_text_title: "Шығарылған мәтін осы жерде пайда болады",
  uploaded_image: "Жүктелген сурет",
  generated_caption: "Генерацияланған сипаттама",
  generated_text_placeholder: "Генерацияланған мәтін осы жерде пайда болады",
  enter_the_text: "Мәтінді енгізіңіз",
  enter_question: "Сұрақты енгізіңіз",
  get_answer: "Жауап алу",
  answer: "Жауап",
  translate: "Аудару",
  translated_text: "Аударылған мәтін",
  translation_successful: "Аударма сәтті",
  document_qa: "Құжат бойынша сұрақтарға жауап беру",
  upload_file: "Файлды жүктеу",
  uploaded_file: "Жүктелген файл",
  ask_question: "Құжат туралы сұрақ қойыңыз",
  ocrr: "Берілген құжатқа негізделген жауаптарды алу үшін құбырлы үлгілер",
};

export default kz;
